
/* M6s 숨기기 start - 08/27/2025 */

document.addEventListener("DOMContentLoaded", function() {
  // URL 조건 확인
  if (window.location.href.includes("/products/ceragem-m6")) {
    // 1) Variant ID로 특정 input 찾기


    var targetInput = document.querySelector(
      'input[value="M6s - Only Massage Chair"]'
    );

    console.log("targetInput", targetInput);
    if (targetInput) {
      // 2) 부모 div 전체를 숨기기
      var parentDiv = targetInput.closest('.pf-vs-radio');
      if (parentDiv) {
        parentDiv.style.display = "none";
      }
    }
  }
});

/* M6s 숨기기 end - 08/27/2025 */